import moment from "moment";
import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { vendorDashboardfromAdmin } from "../../../../../store/actions/vendorAccessActions";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import SuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification";
import SuperAdminSMS from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import { AdminTwilioCallingModal } from "../../superAdminVendor/superAdminVendorTable/firstPageTable/AllVendorTableBody";

const TableBody = ({ data }) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="text-break" onClick={showTr}>
                <td style={{ width: "15%" }}>
                  <div className="vendor-main-section-one">
                    <div className="image-box">
                      <div className="Image-box-section">
                        <Image
                          fluid
                          alt="Restaurant Photo"
                          title={data?._id?.restaurant_name}
                          src={data?._id?.logo_url}
                        />
                        <div className="inside-image-box-discout">
                          <Image
                            fluid
                            alt="Discount Picture"
                            title="Discount Picture"
                            src={require("../../../../../assets/images/superadmin/discount.svg")}
                          />
                        </div>
                      </div>
                      <div>
                        <h5 className="font_14_m mt-3">
                          #{data?._id?._id || ""}
                        </h5>
                      </div>
                    </div>
                    <div className="start-rating-review-box mt-2">
                      <Image
                        fluid
                        alt="wait time"
                        title="wait time"
                        className="star-image-box mr-1"
                        src={require("../../../../../assets/images/superadmin/star.svg")}
                      />
                      <div className="f12-500 d-flex align-items-center w-100">
                        <span className="w-25">{data?.averageRating || "0.0"}</span>
                        <span className="w-100 font_10_r ml-1">
                          ({data?.totalReviews || "0"} reviews)
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <h3 className="font_20_m">{data?._id?.restaurant_name}</h3>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {data?.experienceId?.length || 0}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  {data?.requests?.pendingReqs || 0}
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">{data?.requests?.requests || 0}</div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="font_18_b">
                    {data?._id?.primary_restaurant_type?.length ? data?._id?.primary_restaurant_type[0]?.title || "" : null}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">Active</div>
                </td>
                <td
                  style={{ width: "15%" }}
                  onClick={(e) => {
                    if (!e) var e = window.event;
                    e.cancelBubble = true;
                    if (e.stopPropagation) e.stopPropagation();
                  }}
                >
                  <button
                    onClick={() =>
                      dispatch(
                        vendorDashboardfromAdmin(data?._id?.vendor_id, () => {
                          history.push("/experiencedashboard/pending");
                        })
                      )
                    }
                    className="enViewDashboard btn btn-outline-danger d-flex align-items-center"
                  >
                    <Image
                      src={require("../../../../../assets/images/ActionImages/image/onboarding.svg")}
                      alt="View"
                      title="View"
                      fluid
                      className="mr-2"
                      width="20px"
                    />
                    <div className="f9-500">View Dashboard</div>
                  </button>
                </td>
              </tr>
              {TrDetail && (
                <>
                  <tr className="sd_accordion_body">
                    <td style={{ width: "18%" }}>
                      <div className="f12-400">Contact</div>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <AdminTwilioCallingModal
                          sendData={data?._id?.point_of_contact}
                        />
                        <SuperAdminSMS dataSend={data?._id} />
                        <SuperAdminNotification dataSend={data?._id} />
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">Hours of Operation</div>
                      <div className="f12-400 mt-2">
                        {data?._id?.are_you_open_24_x_7 ? (
                          <>24/7</>
                        ) : (
                          <>
                            {data?._id?.openStatus?.open
                              ? "Closes At"
                              : "Open At"}
                            :{" "}
                            {data?._id?.openStatus?.time
                              ? data?._id?.openStatus?.time?.toString()
                              : moment(new Date()).format("hh:mm A")}
                          </>
                        )}
                      </div>
                    </td>
                    <td style={{ width: "25%" }}>
                      <div className="f12-400">City/Location</div>
                      <div className="f12-400 mt-2">
                        {data?._id?.restaurant_address || ""}
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">Member Since</div>
                      <div className="f12-400 mt-2">
                        {moment(data?._id?.createdAt).format("DD/MM/YYYY")}
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default TableBody;
